import styled from 'styled-components';

export const Wrapper = styled.div<{ isActive: boolean }>`
	background-color: ${({ isActive }) => (isActive ? '#0582ca' : '#ccc')};
	border-radius: 100px;
	height: 18px;
	width: 40px;
	min-width: 40px;
	position: relative;
	margin-right: 12px;
	cursor: pointer;
	transition: background-color 100ms linear;
`;

export const Dot = styled.div<{ isActive: boolean }>`
	position: absolute;
	width: 24px;
	height: 24px;
	background-color: #fff;
	border: 2px solid ${({ isActive }) => (isActive ? '#0582ca' : '#ccc')};
	border-radius: 50%;
	top: 50%;
	transform: translateY(-50%);
	transition: all 100ms linear;
	left: ${({ isActive }) => (isActive ? '17px' : '0px')};
`;
